export * from "./ATypeFAQ";
export * from "./BTypeFAQ";
export * from "./CTypeFAQ";
export * from "./DTypeFAQ";
